module.exports = __webpack_public_path__ + "static/media/mouka-expense.08dde12c.png";